import { createCable, fetchTokenFromHTML } from "@anycable/web"
import { ActionCableConsumer } from "@anycable/core"

const cable = createCable({
  tokenRefresher: fetchTokenFromHTML(),
  protocol: "actioncable-v1-ext-json",
  protocolOptions: {
    pongs: true,
  },
  // logLevel: "debug",
  // logger: console,
})

// ActionCable-kompatible API für custom Channel-Subscriptions (z.B. BLEHandlerChannel)
export const consumer = new ActionCableConsumer(cable)

// Das JWT des Cables steht in <meta name="action-cable-url"> des Layouts und wird nur beim Laden der Seite gelesen.
// An- und Abmelden laufen als Turbo-Visit (im Browser wie in Hotwire Native), die Seite bleibt geladen. Zeigt die neue
// Seite einen anderen Wert, verbindet sich das Cable mit dem neuen JWT neu; die Abonnements werden dabei wieder
// angemeldet. Sonst bliebe es anonym (BLEHandlerChannel lehnt ab) bzw. beim vorigen Benutzer.
const cableURL = () => document.querySelector('meta[name="action-cable-url"]')?.content
let currentCableURL = cableURL()

export function refreshCableIdentity() {
  const url = cableURL()
  if (!url || url === currentCableURL) return

  currentCableURL = url
  cable.transport.setURL(url)
  cable.disconnect()
  cable.connect()
}

document.addEventListener("turbo:load", refreshCableIdentity)

export default cable
